import api from './apiLibrary';

const API = {
    getAdmins(params) {
        return api.get('/api/data/admin', params);
    },
    getAdmin(id, params) {
        return api.get(`/api/data/admin/${id}`, params);
    },
    editAdmin(id, data) {
        return api.put(`/api/data/admin/${id}`, data);
    },
    createAdmin(data) {
        return api.post('/api/auth/admin', data);
    },
    deleteAdmin(id) {
        return api.delete(`/api/admin/${id}`);
    },
    reviveAdmin(id) {
        return api.put(`/api/admin/${id}/revive`);
    },
};

export default API;
